import React, { useState } from "react"
import { Grid, Button, Modal } from "semantic-ui-react"
import { Agreement } from "./../App/Signup/Agreements"
import { AppLayout } from "uikit"

import { ReactComponent as CovidShieldIcon } from "uikit/Icons/covid-shield.svg"
import { ReactComponent as CovidWashIcon } from "uikit/Icons/covid-wash.svg"
import { ReactComponent as CovidMaskIcon } from "uikit/Icons/covid-mask.svg"
import { ReactComponent as CloseIcon } from "uikit/Icons/times-light.svg"

export const ReviewHouseholdBanner = props => {
  return (
    <Grid.Row style={{ padding: "0px" }}>
      <Grid.Column>
        <div
          style={{
            padding: "1em",
            backgroundColor: "#db2828",
            color: "white",
            fontWeight: "bold",
            textAlign: "right",
            height: "4.35em"
          }}
        >
          <span
            style={{
              paddingTop: "0.55em",
              float: "left"
            }}
          >
            REVIEWING
          </span>
          <Button
            onClick={() => props.setCurrentHousehold(null)}
            color="yellow"
          >
            Exit Review
          </Button>
        </div>
      </Grid.Column>
    </Grid.Row>
  )
}

export const CovidBanner = () => {
  return (
    <Grid.Row style={{ padding: "0px" }}>
      <Grid.Column>
        <div
          style={{
            padding: "1em",
            backgroundColor: "#FFD500",
            color: "black",
            fontWeight: "bold",
            textAlign: "right",
            height: "4.35em"
          }}
        >
          <div style={{ float: "left" }}>
            <CovidShieldIcon
              style={{
                height: "40px",
                width: "40px",
                marginRight: "0.5em"
              }}
            />
            <CovidWashIcon
              style={{
                height: "40px",
                width: "40px",
                marginRight: "0.5em"
              }}
            />
            <CovidMaskIcon
              style={{
                height: "40px",
                width: "40px",
                marginRight: "0.5em"
              }}
            />
          </div>
          <div
            style={{
              float: "left",
              paddingTop: "0.55em"
            }}
          >
            <span>COVID Relief Planning</span>
          </div>
          <Button
            href="https://help.savvifi.com/en/articles/4048454-how-to-use-savvi-s-covid-relief-planning-assistant"
            target="_blank"
            rel="noopener noreferrer"
            style={{ backgroundColor: "#FDF2BA" }}
          >
            How to use→
          </Button>
          <Button
            href="https://help.savvifi.com/en/collections/2289225-covid-19-educational-resources"
            target="_blank"
            rel="noopener noreferrer"
            color="black"
          >
            Crisis education center→
          </Button>
        </div>
      </Grid.Column>
    </Grid.Row>
  )
}

export const AgreementsBanner = props => {
  const [showAgreement, toggleShowAgreement] = useState(null)
  return (
    <AppLayout>
      <Grid.Row
        style={{
          margin: "0 1em",
          backgroundColor: "#4a4a4a"
        }}
      >
        <Grid.Column width={14} style={{ paddingRight: 0, paddingLeft: 0 }}>
          <div
            style={{
              color: "white",
              textAlign: "right",
              height: "4.35em",
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <div
              style={{
                float: "left",
                textAlign: "left",
                paddingRight: "1em"
              }}
            >
              <span>
                <span style={{ fontWeight: "bold" }}>We’ve updated our </span>
                {props.agreements.map((ag, i) => (
                  <span
                    onClick={() => toggleShowAgreement(ag)}
                    key={i}
                    style={{
                      color: "#00b5ed",
                      textDecoration: "underline",
                      cursor: "pointer"
                    }}
                  >
                    {ag.title}
                    <span style={{ color: "white" }}>
                      {i < props.agreements.length - 2
                        ? ", "
                        : i === props.agreements.length - 2
                        ? " and "
                        : ""}
                    </span>
                  </span>
                ))}
                <span style={{ fontWeight: "bold" }}>
                  . By continuing to use our services, you acknowledge and
                  accept these updates.
                </span>
              </span>
            </div>
          </div>
        </Grid.Column>
        <Grid.Column
          width={2}
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "center",
            paddingRight: 0
          }}
        >
          <div
            style={{
              textAlign: "right",
              cursor: "pointer",
              color: "white",
              width: "2em",
              height: "2em"
            }}
            onClick={props.close}
          >
            <CloseIcon style={{ width: "2em", height: "2em" }} />
          </div>
        </Grid.Column>
      </Grid.Row>
      {showAgreement ? (
        <Modal
          open={true}
          onClose={() => toggleShowAgreement(null)}
          size="large"
          closeOnDimmerClick={false}
          closeOnDocumentClick={false}
        >
          <Modal.Header
            style={{
              position: "absolute",
              width: "100%",
              top: 0,
              zIndex: "inherit"
            }}
          >
            {showAgreement.title}
            <div
              style={{
                float: "right",
                cursor: "pointer",
                color: "red",
                width: "20px",
                height: "20px",
                position: "absolute",
                top: "20px",
                right: "24px"
              }}
              onClick={() => toggleShowAgreement(null)}
            >
              <CloseIcon />
            </div>
          </Modal.Header>
          <Modal.Content
            style={{
              width: "100%",
              height: "92%",
              marginTop: "8%",
              paddingTop: "0px",
              paddingBottom: "0px"
            }}
          >
            <Agreement isModal={true} id={showAgreement.id} />
          </Modal.Content>
        </Modal>
      ) : null}
    </AppLayout>
  )
}
